export default __webpack_public_path__ + "static/media/chevron-down-blue.4407b386.svg";